<div class="modal">
  <div class="modal-ctn picker">

    <div class="options">
      <span class="picker-title">{{ 'UI.PICK.ANALYZER' | translate }}</span>
      <df-input type="search" prefixIcon="heroMagnifyingGlass" allowClear (valueChange)="filterAnalyzers($event)" />
      <button type="button" class="icon-action" title="Close" (click)="close()"><ng-icon name="heroXMark" size="20"/></button>
    </div>

    @if (showTrainSelector) {
      <div class="picker-train">
        <df-form-field [label]="'UI.NEW_MISSION.TRAIN' | translate">
          <df-select inputId="analyzerTrain" [placeholder]="'UI.SELECT' | translate"
            [options]="trainOptions" [formControl]="selectedTrainFC" />
        </df-form-field>
      </div>
    }

    <div class="analyzers picker-list">
      @for (analyzer of displayedAnalyzers; track analyzer) {
        <div class="analyzer picker-item">
          <div class="logo">
            <div class="equipments">
              <ng-icon name="heroCpuChip" size="18"/>
            </div>
            <a>{{ analyzer.analyzerId }}</a>
          </div>
          <div class="info">
            <a>{{ 'MATERIAL.ANALYZER.MODEL' | translate }}: {{ analyzer.analyzermodelName }}</a>
            <a>{{ 'MATERIAL.ANALYZER.RANGE' | translate }}: {{ analyzer.analyzermodelGas }}</a>
            <a>{{ 'MATERIAL.TELEMETRY' | translate }}: {{ analyzer.telemetrysuppliername }}</a>
            <a>{{ analyzer.exatmregulation }}: {{ analyzer.exatmclasse }}</a>
          </div>
          <df-button size="sm" variant="primary" class="add" [disabled]="selectedTrainFC.invalid"
            (onClick)="addAnalyzer(analyzer)">{{ 'UI.SELECT' | translate }}</df-button>
        </div>
      }
    </div>

  </div>
</div>
